import { render, staticRenderFns } from "./CommentsModuleComponent.vue?vue&type=template&id=2af2bcd2&scoped=true&"
import script from "./CommentsModuleComponent.vue?vue&type=script&lang=js&"
export * from "./CommentsModuleComponent.vue?vue&type=script&lang=js&"
import style0 from "./CommentsModuleComponent.vue?vue&type=style&index=0&id=2af2bcd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af2bcd2",
  null
  
)

export default component.exports